import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { catchError, of } from 'rxjs';
import { CommonModule } from '@angular/common';
import { SharedService } from '../../services/shared.service';
import { Modal } from 'bootstrap';
import { CommonEventService } from '../../services/common-event.service';

@Component({
  selector: 'app-full-image',
  imports: [CommonModule],
  templateUrl: './full-image.component.html',
  styleUrl: './full-image.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class FullImageComponent implements AfterViewInit{
  @ViewChild('fullImageModal', { static: false }) fullImageModal!: ElementRef;
  url: string = '';
  minutes: number = 1;

  private modalInstance!: Modal;

  lastRelativeUrl: string = '';

  urlImage: string = '';

  constructor(
    private sharedService: SharedService,
    private commonEventService: CommonEventService
  ) { 
    this.commonEventService.globalPhoto$.subscribe(url => {
      if(url){
        this.url = url;
        this.getReadSignedUrl();
        this.openModal();
      }
    });
  }

  getReadSignedUrl() {
    if (this.url) {
      this.sharedService.getReadSignedUrl({path: this.url, minutes: this.minutes})
        .pipe(
          catchError((err) => {
            console.error('Error al obtener la imagen:', err);
            return of(null);
          })
        )
        .subscribe((data: any) => {
          if (data && data.success) {
            this.urlImage = data.url;
          } else {
            this.urlImage = '';
          }
        });
    } else {
      this.urlImage = '';
    }
  }


  ngAfterViewInit(): void {
    const modalElement = this.fullImageModal.nativeElement;
    this.modalInstance = new Modal(modalElement);
    this.getReadSignedUrl();
  }

  openModal() {
    this.modalInstance.show();
  }

  closeModal() {
    this.modalInstance.hide();
  }
  
}
